module.exports = "/lucky-balls/img/bigball/BigBall_010.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/bigball/BigBall_010.png
// module id = 905
// module chunks = 0